import clsx from "clsx";
import { HTMLProps, ReactNode } from "react";
import { DataPanel } from "react-migration/components/DataPanel";

type WrapperType = Omit<HTMLProps<HTMLDivElement>, "title"> & {
  title: ReactNode;
  tooltip?: string | ReactNode;
  "data-testid"?: string;
};

export const Wrapper = ({ title, tooltip, children, "data-testid": dataTestId, className }: WrapperType) => {
  return (
    <DataPanel.Cell
      title={title}
      tooltip={tooltip}
      variant="light"
      className={clsx("px-4 py-4 rounded-xl relative", className)}
      data-testid={dataTestId}
    >
      {children}
    </DataPanel.Cell>
  );
};
